import type { TFunction } from "i18next"

export const APP_ERROR_SOURCE = {
  CONNECTIVITY: "connectivity",
  TABLET_DATA: "tablet_data",
  TABLET_PRINTER: "tablet_printer",
  REGISTRATION_DATA: "registration_data",
  REGISTRATION_FLOW: "registration_flow",
  AUTH: "auth",
  ONBOARDING: "onboarding",
  GENERAL: "general",
} as const

export type AppErrorSource =
  (typeof APP_ERROR_SOURCE)[keyof typeof APP_ERROR_SOURCE]

export type AppErrorWithSource = {
  message: string
  source: AppErrorSource
}

export type AppErrorPayload = string | null | AppErrorWithSource

export const createAppError = (
  message: string,
  source: AppErrorSource,
): AppErrorWithSource => ({
  message,
  source,
})

export const registrationFlowError = (message: string) =>
  createAppError(message, APP_ERROR_SOURCE.REGISTRATION_FLOW)

export const onboardingError = (message: string) =>
  createAppError(message, APP_ERROR_SOURCE.ONBOARDING)

type AppErrorDispatcher = (payload: AppErrorPayload) => void

export const dispatchFlowError = (
  dispatchAppError: AppErrorDispatcher,
  t: TFunction,
  message?: string | null,
) => {
  const resolvedMessage = message?.trim() ? message : t("tablet.general_error")
  dispatchAppError(registrationFlowError(resolvedMessage))
}
